import axios from "axios";
import { Article } from "./updateArticle";

export const createArticle = async (token: string): Promise<Article | null> => {
    if (!token) {
        console.error("Admin token gerekli");
        return null;
    }

    try {
        const headers = { Authorization: `Bearer ${token}` };

        const response = await axios.post(
            "https://portfoliom-backend.vercel.app/articles",
            {}, // Backend zaten örnek değerleri kullanıyor
            { headers }
        );

        return response.data || null;
    } catch (error) {
        if (axios.isAxiosError(error)) {
            console.error("Axios hatası:", error.response?.data || error.message);
        } else {
            console.error("Bilinmeyen hata:", error);
        }
        return null;
    }
};
